import { JAVA_API_STATUS } from '../../utils/axios-interceptor';
import { fetchHistory } from './HistoryDrawerApiService';
import { AicaHistoryResponse, HistoryEntry } from '../../types/ownerHistory';

export const getHistory = async (payload: { referenceId: string; key: string }): Promise<HistoryEntry[] | false> => {
    try {
        const response = await fetchHistory(payload);
        const apiResponse: AicaHistoryResponse = response.data;

        if (apiResponse.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return apiResponse.data ?? [];
        }

        return false;
    } catch (err) {
        return false;
    }
};
